<template>
        <v-form @submit.prevent="onSubmit" novalidate class="elevation-2 pa-3">
          <Fields
            v-bind="{fields, object: formData, errors: formErrors}">
          </Fields>
          <div v-if="link === false">Link nieprawidłowy</div>
          <iframe v-if="link" width="420" height="315"
            :src="link">
          </iframe>
          <div class="mt-1">
          <v-btn variant="secondary" @click="normalize">Sprawdź</v-btn>
          <v-btn type="submit" color="primary">Zapisz</v-btn>
          </div>

        </v-form>
</template>

<script>
import {createAdminVideo, createTrainerVideo, updateAdminVideo, updateTrainerVideo} from './api'
import {YouTubeUrlNormalize} from '@/utils/YouTubeUrlNormalize'
import _ from 'lodash'
import Fields from '@/forms/Fields'
import formMixin from '@/utils/formMixin'
import { mapGetters } from 'vuex'

export default {
  components: {Fields},
  mixins: [formMixin],
  props: {
    video: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      link: null,
      isUpdate: false,
      formData: {
      }
    }
  },
  computed: {
    ...mapGetters(['trainer', 'isAdmin', 'isTrainer']),
    fields () {
      return [
        {comp: 'text', id: 'link', label: 'Link do wideo:', listeners: {change: this.normalize}}
      ]
    },
    message () {
      return this.isUpdate ? 'Wideo zostało edytowane' : 'Wideo zostało dodane'
    }
  },
  created () {
    this.formData = _.cloneDeep(this.video)
    if (this.video.id) {
      this.isUpdate = true
      this.link = this.formData.link
    }
  },
  methods: {
    normalize () {
      let o = YouTubeUrlNormalize(this.formData.link)
      this.formData.link = o.link
      if (o.error) {
        this.link = false
      } else {
        this.link = this.formData.link
      }
    },
    submit (data) {
      let promise
      if (this.isUpdate) {
        if (this.isAdmin) {
          promise = updateAdminVideo(data)
        } else if (this.isTrainer) {
          promise = updateTrainerVideo(this.trainer, data)
        }
      } else {
        if (this.isAdmin) {
          promise = createAdminVideo(data)
        } else if (this.isTrainer) {
          promise = createTrainerVideo(this.trainer, data)
        }
        promise = promise.then((data) => {
          this.formData = {}
          this.validation.reset()
          return data
        })
      }
      return promise
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/videos/VideoForm.vue